import React, { useState } from 'react';
import * as serviceWorker from '../../serviceWorker';

const initialState = {
  assetsUpdateReady: false,
  assetsCached: false,
  updateAssets: () => undefined
};

const ServiceWorkerContext = React.createContext<{
  assetsUpdateReady: boolean,
  assetsCached: boolean,
  updateAssets: () => void;
}>(initialState);

function ServiceWorkerProvider(props: any) {
  const [waitingServiceWorker, setWaitingServiceWorker] = useState<ServiceWorker | null>(null);
  const [assetsUpdateReady, setAssetsUpdateReady] = useState<boolean>(false);
  const [assetsCached, setAssetsCached] = useState<boolean>(false);

  const value = React.useMemo(
    () => ({
      assetsUpdateReady,
      assetsCached,
      updateAssets: () => {
        console.log('updating assets!');
        if (waitingServiceWorker) {
          waitingServiceWorker!.addEventListener('statechange', (event: any) => {
            if (event.target.state === 'activated') {
              window.location.reload();
            }
          });

          waitingServiceWorker!.postMessage({ type: 'SKIP_WAITING' });
        }
      }
    }),
    [assetsUpdateReady, assetsCached, waitingServiceWorker]
  );

  React.useEffect(() => {
    serviceWorker.register({
      onUpdate: (registration: ServiceWorkerRegistration) => {
        setWaitingServiceWorker(registration.waiting);
        setAssetsUpdateReady(true);
      },
      onSuccess: () => {
        setAssetsCached(true);
      }
    });
  }, []);

  // do this for validation as well
  return <ServiceWorkerContext.Provider value={value} {...props} />;
}

function useServiceWorker() {
  const context = React.useContext(ServiceWorkerContext);

  if (!context) {
    throw new Error(
      'useServiceWorker must be used within a ServiceWorkerProvider'
    );
  }

  return context;
}

export { ServiceWorkerProvider, useServiceWorker };